import { useContext } from 'react';
import Compare from '../Compare';
import Stack from '../../../shared/layouts/Stack';
import CategoryHeader from '../CategoryHeader';
import { CompareContext } from '../ComparePage';
import {useTranslation} from "react-i18next";

const SECTION = 'residence_address';

const CompareAddressSection = () => {
  const {
    showOnlyDiff,
    hasDiff,
    shouldShow,
    ownAddressData,
    otherAddressData,
    handleAddressDataChange,
    addressFields,
    setOwnAddressData,
    setCopiedFields,
    hasSectionCopiedFields,
  } = useContext(CompareContext);

  const { t } = useTranslation();

  const handleDataChange = (e) => handleAddressDataChange(e, SECTION);

  if (
    showOnlyDiff &&
    !hasSectionCopiedFields(SECTION) &&
    !hasDiff(addressFields, ownAddressData, otherAddressData)
  )
    return null;

  return (
    <Stack space="l">
      <CategoryHeader>
        <span>{t('Adresgegevens')}</span>
        <span>{t('Adresgegevens')}</span>
      </CategoryHeader>
      <Stack space="m">
        {shouldShow(
          ['zipcode', 'housenumber', 'housenumber_addition'],
          ownAddressData,
          otherAddressData,
          SECTION
        ) && (
          <Compare
            label={t("Postcode, huisnummer en toevoeging")}
            name="housenumber"
            section={SECTION}
            leftValue={[
              ownAddressData?.zipcode,
              ownAddressData?.housenumber,
              ownAddressData?.housenumber_addition,
            ]}
            rightValue={[
              otherAddressData?.zipcode,
              otherAddressData?.housenumber,
              otherAddressData?.housenumber_addition,
            ]}
            onUpdate={(e) => {
              const [
                zipcode,
                housenumber,
                housenumber_addition,
              ] = e.target.value;
              setCopiedFields((values) => [
                ...values,
                `${SECTION}-zipcode`,
                `${SECTION}-housenumber`,
                `${SECTION}-housenumber_addition`,
              ]);
              setOwnAddressData(
                {
                  ...ownAddressData,
                  housenumber,
                  zipcode,
                  housenumber_addition,
                },
                false
              );
            }}
          />
        )}
        {shouldShow('street', ownAddressData, otherAddressData, SECTION) && (
          <Compare
            label={t("Straatnaam")}
            name="street"
            section={SECTION}
            leftValue={ownAddressData?.street}
            rightValue={otherAddressData?.street}
            onUpdate={handleDataChange}
          />
        )}
        {shouldShow('place', ownAddressData, otherAddressData, SECTION) && (
          <Compare
            label={t("Plaatsnaam")}
            name="place"
            section={SECTION}
            leftValue={ownAddressData?.place}
            rightValue={otherAddressData?.place}
            onUpdate={handleDataChange}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default CompareAddressSection;
